export const DEFAULT_ASSET_TYPES = [
  {
    id: "53e0ebd5-8c2c-472d-9909-ed4e61a13e22",
    title: "Headquarters (HQ)",
    icon: "star",
    color: "#000000",
    enabled: true,
    isSystemType: true,
    orderBy: 1,
  },
  {
    id: "67762147-6c70-4b5a-9975-a3f3049351e4",
    title: "Regional HQ",
    icon: "star",
    color: "#000000",
    enabled: true,
    isSystemType: true,
    orderBy: 2,
  },
  {
    id: "903c47dd-8b78-4bc9-a9c3-6efb15cc2a41",
    title: "Office",
    icon: "star",
    color: "#000000",
    enabled: true,
    isSystemType: true,
    orderBy: 3,
  },
  {
    id: "d6401971-e40b-4023-8473-06e801ec5d24",
    title: "Manufacturing site",
    icon: "star",
    color: "#000000",
    enabled: true,
    isSystemType: true,
    orderBy: 4,
  },
  {
    id: "58d07132-75f8-45df-bc75-872f073796ac",
    title: "Tier 1 Supplier",
    icon: "star",
    color: "#000000",
    enabled: true,
    isSystemType: true,
    orderBy: 5,
  },
  {
    id: "5883abf0-da32-424c-8314-0a340617d94b",
    title: "Tier 2 Supplier",
    icon: "star",
    color: "#000000",
    enabled: true,
    isSystemType: true,
    orderBy: 6,
  },
];

export const ASSET_TYPES_DESCRIPTION =
  "Asset types are mandatory. You can customize your Asset Types here. Asset Types will be utilized for filtering and sorting. Use some or all of our suggestions, or some of your own. </br></br> Each asset type will be associated with an icon to distinguish them on the map; you can choose the icon in the asset type dropdown or use the defaults.";

export const ASSET_TYPES_CUSTOM_DESCRIPTION =
  "Optional: Add Custom Asset Types";

export const ASSET_AOI_EDITOR_MAP = "asset-aoi-editor-map";

export const ASSET_AOI_MAX_AREA = 100000000;

export const ASSET_WORLD_WIDE_AOI = {
  type: "Feature",
  properties: {
    name: "World Wide AOI",
    aoiIds: null,
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [-180, -90],
        [180, -90],
        [180, 90],
        [-180, 90],
        [-180, -90],
      ],
    ],
  },
};

export const ASSET_CUSTOM_AOI = {
  type: "Feature",
  properties: { name: "CUSTOM AOI", aoiIds: null },
  geometry: null,
};

export const ASSET_LOCATION_AOI = {
  type: "Feature",
  properties: { name: "LOCATION AOI", aoiIds: null },
  geometry: null,
};

export const ASSET_COLORS = [
  {
    hex: "#000000",
    color: "Black",
  },
  {
    hex: "#F9CE52",
    color: "Yellow",
  },
  {
    hex: "#DE748A",
    color: "Pink",
  },
  {
    hex: "#3A8176",
    color: "Green",
  },
  {
    hex: "#77518C",
    color: "Purple",
  },
  {
    hex: "#50A8C0",
    color: "Turquoise",
  },
];
export const ASSET_ICONS = [
  {
    text: "Anchor",
    value: "anchor",
    fileName: "asset_anchor",
  },
  {
    text: "Bed",
    value: "bed",
    fileName: "asset_bed",
  },
  {
    text: "Chart",
    value: "chart",
    fileName: "asset_chart",
  },
  {
    text: "Circle",
    value: "circle",
    fileName: "asset_circle",
  },
  {
    text: "Cog",
    value: "cog",
    fileName: "asset_cog",
  },
  {
    text: "Cubes",
    value: "cubes",
    fileName: "asset_cubes",
  },
  {
    text: "Database",
    value: "database",
    fileName: "asset_database",
  },
  {
    text: "Factory",
    value: "factory",
    fileName: "asset_factory",
  },
  {
    text: "Fire",
    value: "fire",
    fileName: "asset_fire",
  },
  {
    text: "Institution",
    value: "institution",
    fileName: "asset_institution",
  },
  {
    text: "Mining",
    value: "mining",
    fileName: "asset_mining",
  },
  {
    text: "Office",
    value: "office",
    fileName: "asset_office",
  },
  {
    text: "Offshore Rig",
    value: "offshorerig",
    fileName: "asset_offshorerig",
  },
  {
    text: "Oil Rig",
    value: "oilrig",
    fileName: "asset_oilrig",
  },
  {
    text: "Plane",
    value: "plane",
    fileName: "asset_plane",
  },
  {
    text: "Plug",
    value: "plug",
    fileName: "asset_plug",
  },
  {
    text: "Plus",
    value: "plus",
    fileName: "asset_plus",
  },
  {
    text: "Shield",
    value: "shield",
    fileName: "asset_shield",
  },
  {
    text: "Square",
    value: "square",
    fileName: "asset_square",
  },
  {
    text: "Star",
    value: "star",
    fileName: "asset_star",
  },
  {
    text: "Target",
    value: "target",
    fileName: "asset_target",
  },
  {
    text: "Train",
    value: "train",
    fileName: "asset_train",
  },
  {
    text: "Warning",
    value: "warning",
    fileName: "asset_warning",
  },
];

export const TIME_OPTIONS = [
  {
    value: {
      label: "Today",
      isRelative: true,
      start: 0,
      end: 0,
    },
  },
  {
    value: {
      label: "Yesterday",
      isRelative: true,
      start: 1,
      end: 1,
    },
  },
  {
    value: {
      label: "Past 7 Days",
      isRelative: true,
      start: 7,
      end: 0,
    },
  },
  {
    value: {
      label: "Past 30 Days",
      isRelative: true,
      start: 30,
      end: 0,
    },
  },
  {
    value: {
      label: "Past 60 Days",
      isRelative: true,
      start: 60,
      end: 0,
    },
  },
  {
    value: {
      label: "Past 90 Days",
      isRelative: true,
      start: 90,
      end: 0,
    },
  },
];
